import React from 'react';
import {Redirect} from 'react-router';
import {AppState} from 'acscp/store';
import { userCanAccessCharters, userCanAccessLoyalty, userIsLoggedIn } from 'acscp/store/helpers/authHelper';
import {connect} from 'react-redux';

interface HomePageCoreStateProps {
    isLoggedIn: boolean;
    canAccessCharters: boolean;
    canAccessLoyalty: boolean;
    isNonJetPortalUser: boolean;
}

const HomePageCore: React.SFC<HomePageCoreStateProps> = (props: HomePageCoreStateProps) => {
    if (!props.isLoggedIn && !props.isNonJetPortalUser) {
        return (<Redirect to="/login"/>);
    }
    if (props.canAccessCharters) {
        return (<Redirect to={CHARTERS_HOME}/>);
    }
    if (props.canAccessLoyalty) {
        return (<Redirect to="/loyalty"/>);
    }
    return (<Redirect to={CHARTERS_HOME}/>);
};

function mapStateToProps(state: AppState, ownProps: {}): HomePageCoreStateProps {
    return {
        isLoggedIn: state.auth.guestLogin || userIsLoggedIn(state.auth),
        canAccessCharters: userCanAccessCharters(state.auth),
        canAccessLoyalty: userCanAccessLoyalty(state.auth),
        isNonJetPortalUser: state.auth.isNonJetPortalUser
    };
}

export const HomePage = connect(mapStateToProps)(HomePageCore);
